import { Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { COLOR } from '../../constants'
import { D4_Fn_View_Demande } from '../../types'
import DemandeMontant from './DemandeMontant'

const DemandeDetailTags = ({ item }: { item: D4_Fn_View_Demande }) => {
  const actionsCount = item.actions_aggregate.aggregate?.count ?? 0

  const emetteur =
    item?.emetteur?.societes && item?.emetteur?.societes?.length > 0
      ? item?.emetteur?.societes[0].raisonsociale
      : item.emetteur?.nom

  return (
    <>
      <DemandeMontant minmontant={item.minmontant} maxmontant={item.maxmontant} />
      {actionsCount > 0 && (
        <Tooltip title={`${actionsCount} tâche${actionsCount > 1 ? 's' : ''}`}>
          <Tag color="blue">{item.actions_aggregate.aggregate?.count}</Tag>
        </Tooltip>
      )}
      {emetteur && (
        <Tag color={COLOR.blue}>
          <Typography.Text style={{ color: COLOR.white }}>{emetteur}</Typography.Text>
        </Tag>
      )}
      {item.typedemande === 'Sinistre' && <Tag color={COLOR.red}>{item.typedemande}</Tag>}
      {item.urgence === 2 && <Tag color="red">urgent</Tag>}
    </>
  )
}

export default DemandeDetailTags
